<div [formGroup]="form">
  <div class="row">
    <app-field
      class="col-md-12"
      label="Gender"
      [required]="false"
      errorMessage="Please select your gender"
      [disabled]="isDisabled">
      @for (gender of genderList; track gender) {
        <label class="inline-label">
          <input
            type="radio"
            [value]="gender.val"
            [name]="genderFormControlName"
            [formControlName]="genderFormControlName" />
            <span>
              {{ gender.name }}
              @if (gender.tooltip) {
                <app-tool-tip [trigger]="gender.tooltip"></app-tool-tip>
              }
            </span>
          </label>
        }
      </app-field>
    </div>
    <div class="row">
      @if (showOtherGender) {
        <app-field
          class="col-md-12"
          label="Other Gender"
          [required]="false"
          errorMessage="Please enter your gender"
          [disabled]="isDisabled">
          <label class="inline-label">
            <input type="text" [name]="otherGenderFormControlName" [formControlName]="otherGenderFormControlName" />
          </label>
        </app-field>
      }
    </div>
  </div>
